import React from 'react';
import { ImageFadeIn } from '../components/animations/ImageFadeIn';
import { ScrollReveal } from '../components/animations/ScrollReveal';
// Simple team card without expandable functionality
const TeamCard = ({
  name,
  title
}: {
  name: string;
  title: string;
}) => {
  return <div className="bg-gray-900/50 p-6 rounded-2xl border border-gray-800/50 text-white h-full flex flex-col" data-id="element-1101">
      <div className="aspect-[1/1] w-full mb-6 overflow-hidden rounded-xl" data-id="element-1102">
        <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/fZa81XHffrZCe8WfjqY5ov/profile_pic.png" alt={`${name} profile`} className="w-full h-full object-cover" data-id="element-1103" />
      </div>
      <div className="mt-auto" data-id="element-1104">
        <h3 className="text-xl font-semibold text-white mb-1" data-id="element-1105">{name}</h3>
        <p className="text-gray-300 text-sm" data-id="element-1106">{title}</p>
      </div>
    </div>;
};
const TeamPage = () => {
  const instructorTeam = [{
    name: 'Tim M.',
    title: '35 year military security training expert'
  }, {
    name: 'Rony J.',
    title: 'Experienced corporate security executive'
  }, {
    name: 'Mo V.',
    title: 'Nationally recognized doctor and specialty surgeon'
  }, {
    name: 'David S.',
    title: 'Nationally recognized corporate executive and leadership expert'
  }, {
    name: 'David A.',
    title: 'Nationally recognized emergency management expert and trainer with 38 years of experience'
  }, {
    name: 'Bert S.',
    title: '15 years as experienced business owner and licensed building contractor; 28 years professional teaching experience'
  }];
  return <div className="w-full min-h-screen bg-center bg-cover bg-no-repeat bg-gray-900" style={{
    backgroundImage: `url(https://uploadthingy.s3.us-west-1.amazonaws.com/ib3Dyczi1YEyT6WYET97wp/bgbluee2.png)`
  }} data-id="element-1107">
      {/* Header Section */}
      <div className="pt-40 sm:pt-48 md:pt-56 pb-6 sm:pb-10" data-id="element-1108">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-light text-white text-center tracking-normal px-4" data-id="element-1109">
          Meet the Board
        </h1>
      </div>
      {/* Instructor Team Section */}
      <ScrollReveal animation="fade" data-id="element-1110">
        <div className="py-12 sm:py-16 md:py-24" data-id="element-1111">
          <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-1112">
            <div className="mb-16 sm:mb-24" data-id="element-1113">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-1114">
                {instructorTeam.map((member, index) => <TeamCard key={index} name={member.name} title={member.title} data-id="element-1115" />)}
              </div>
            </div>
          </div>
        </div>
      </ScrollReveal>
    </div>;
};
export default TeamPage;